import * as tslib_1 from "tslib";
import { Num, Form } from '@swim/recon';
var TimeZone = (function () {
    function TimeZone(offset) {
        this._offset = offset;
    }
    Object.defineProperty(TimeZone.prototype, "name", {
        get: function () {
            if (this._offset === 0) {
                return 'UTC';
            }
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimeZone.prototype, "offset", {
        get: function () {
            return this._offset;
        },
        enumerable: true,
        configurable: true
    });
    TimeZone.prototype.equals = function (that) {
        if (this === that) {
            return true;
        }
        else if (that instanceof TimeZone) {
            return this._offset === that._offset;
        }
        return false;
    };
    TimeZone.prototype.hashCode = function () {
        return this._offset;
    };
    TimeZone.forName = function (name) {
        if (name === 'UTC') {
            return TimeZone.UTC;
        }
        throw new Error('unknown time zone: ' + name);
    };
    TimeZone.forOffset = function (offset) {
        if (offset === 0) {
            return TimeZone.UTC;
        }
        else {
            return new TimeZone(offset);
        }
    };
    TimeZone.fromAny = function (zone) {
        if (zone instanceof TimeZone) {
            return zone;
        }
        else if (typeof zone === 'string') {
            return TimeZone.forName(zone);
        }
        else if (typeof zone === 'number') {
            return TimeZone.forOffset(zone);
        }
        throw new TypeError('' + zone);
    };
    TimeZone.UTC = new TimeZone(0);
    TimeZone.Form = undefined;
    TimeZone.Local = TimeZone.forOffset(-new Date().getTimezoneOffset());
    return TimeZone;
}());
export { TimeZone };
var TimeZoneForm = (function (_super) {
    tslib_1.__extends(TimeZoneForm, _super);
    function TimeZoneForm(unit) {
        if (unit === void 0) { unit = TimeZone.UTC; }
        var _this = _super.call(this) || this;
        _this.unit = unit;
        return _this;
    }
    TimeZoneForm.prototype.mold = function (zone) {
        zone = TimeZone.fromAny(zone);
        return Num.valueOf(zone._offset);
    };
    TimeZoneForm.prototype.cast = function (value) {
        var offset = value.numberValue();
        if (offset !== undefined) {
            return TimeZone.forOffset(offset);
        }
        var name = value.stringValue();
        if (name !== undefined) {
            return TimeZone.forName(name);
        }
        return undefined;
    };
    return TimeZoneForm;
}(Form));
TimeZone.Form = new TimeZoneForm();
//# sourceMappingURL=data:application/json;base64,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